export const dateFormat = (date: string) => {
    return `${new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })}`
}

export const convertDateFormat = (dateString: string) => {
    // Parse the input date string
    const date = new Date(dateString)

    // Get the year, month, and day components
    const year = date.getFullYear()
    // Month is zero-based, so we need to add 1 to get the correct month
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    // Format the date in the desired format
    const formattedDate = `${year}-${month}-${day}`

    return formattedDate
}
